import React, { useState } from "react";
import "./services.css";

const Services = () => {
  const [toggleState, setToogleState] = useState(0);

  const toggleTab = (index) => {
    setToogleState(index);
  };

  return (
    <section className="services section" id="services">
      <h2 className="section__title">Services</h2>
      <span className="section__subtitle">What I offer</span>

      <div className="services__container container grid">
        <div className="services__content">
          <div>
            <i className="uil uil-window services__icon"></i>
            <h3 className="services__title">FrontEnd developer</h3>

            <span className="services__button" onClick={() => toggleTab(1)}>
              View More
              <i className="uil uil-arrow-right services__button-icon"></i>
            </span>

            <div
              className={
                toggleState === 1
                  ? "services__modal active-modal"
                  : "services__modal"
              }
            >
              <div className="services__modal-content">
                <i
                  className="uil uil-times services__modal-close"
                  onClick={() => toggleTab(0)}
                ></i>

                <h3 className="services__modal-title">FrontEnd developer</h3>
                <p className="services__modal-description">
                  My expertise lies in front-end technologies such as
                  JavaScript, React, HTML, CSS, and Bootstrap. I have experience
                  in creating and implementing the visual elements of a website.
                  <br />
                  <br />I am still gaining experience, but I have a strong
                  understanding of the software development life cycle and
                  development best practices, and I am able to work well under
                  the guidance of more experienced frontend developers. I am
                  dedicated to learning and improving my skillset by keeping up
                  with the latest trends and technologies in the industry.
                </p>

                <ul className="services__modal-services grid">
                  <li className="services__modal-service">
                    <i className="uil uil-check-circle services__moral-icon"></i>
                    <p className="services__modal-info">
                      Single-Page Application.
                    </p>
                  </li>

                  <li className="services__modal-service">
                    <i className="uil uil-check-circle services__moral-icon"></i>
                    <p className="services__modal-info">
                      Web page development.
                    </p>
                  </li>

                  <li className="services__modal-service">
                    <i className="uil uil-check-circle services__moral-icon"></i>
                    <p className="services__modal-info">
                      I create UX element interactions.
                    </p>
                  </li>

                  <li className="services__modal-service">
                    <i className="uil uil-check-circle services__moral-icon"></i>
                    <p className="services__modal-info">
                      Axios to make client-side requests to the server.
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="services__content">
          <div>
            <i className="uil uil-server services__icon"></i>
            <h3 className="services__title">BackEnd developer</h3>

            <span className="services__button" onClick={() => toggleTab(2)}>
              View More{" "}
              <i className="uil uil-arrow-right services__button-icon"></i>
            </span>

            <div
              className={
                toggleState === 2
                  ? "services__modal active-modal"
                  : "services__modal"
              }
            >
              <div className="services__modal-content">
                <i
                  className="uil uil-times services__modal-close"
                  onClick={() => toggleTab(0)}
                ></i>

                <h3 className="services__modal-title">BackEnd developer</h3>
                <p className="services__modal-description">
                  I am a junior backend developer with experience in building
                  server-side applications using Javascript, NodeJS, ExpressJS,
                  MongoDB, and Postman. <br />
                  <br />I know how to use NodeJS to create a web server, and use
                  ExpressJS as a web framework to handle HTTP requests and
                  routing.
                  <br /> I am familiar with MongoDB as a NoSQL database to store
                  and retrieve data, and I can use Postman to test API
                  endpoints. <br />I have a basic understanding of using Node
                  Package Manager (npm) for package management and Git for
                  version control.
                </p>

                <ul className="services__modal-services grid">
                  <li className="services__modal-service">
                    <i className="uil uil-check-circle services__moral-icon"></i>
                    <p className="services__modal-info">
                      ExpressJS to handle HTTP requests.
                    </p>
                  </li>

                  <li className="services__modal-service">
                    <i className="uil uil-check-circle services__moral-icon"></i>
                    <p className="services__modal-info">
                      MongoDB as a NoSQL database.
                    </p>
                  </li>

                  <li className="services__modal-service">
                    <i className="uil uil-check-circle services__moral-icon"></i>
                    <p className="services__modal-info">Git & NPM control.</p>
                  </li>

                  <li className="services__modal-service">
                    <i className="uil uil-check-circle services__moral-icon"></i>
                    <p className="services__modal-info">
                      Postman to test API endpoints.
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="services__content">
          <div>
            <i className="uil uil-lightbulb-alt services__icon"></i>
            <h3 className="services__title">Great attitudes</h3>

            <span className="services__button" onClick={() => toggleTab(3)}>
              View More{" "}
              <i className="uil uil-arrow-right services__button-icon"></i>
            </span>

            <div
              className={
                toggleState === 3
                  ? "services__modal active-modal"
                  : "services__modal"
              }
            >
              <div className="services__modal-content">
                <i
                  className="uil uil-times services__modal-close"
                  onClick={() => toggleTab(0)}
                ></i>

                <h3 className="services__modal-title">Great mindset</h3>
                <p className="services__modal-description">
                  As a junior web developer, I possess a strong willingness to
                  continuously learn new technologies, programming languages,
                  and development methodologies in order to stay current in the
                  field and improve my skills. <br />My curiosity drives me to be
                  creative, seek out new information and find ways to overcome
                  challenges. I approach my work with enthusiasm and a can-do
                  mindset, and I am always paying attention to detail in order
                  to write clean, efficient and maintainable code. My
                  problem-solving skills enable me to analyze, design and
                  develop solutions to technical problems. <br />I am a great team
                  player who actively contributes to team goals. I always
                  demonstrate a high level of professionalism through my
                  communication skills and respectful behavior towards
                  colleagues and management. I am also very effective in
                  communicating my ideas, technical details and progress with
                  both technical and non-technical people, actively listening to
                  feedback.
                </p>

                <ul className="services__modal-services grid">
                  <li className="services__modal-service">
                    <i className="uil uil-check-circle services__moral-icon"></i>
                    <p className="services__modal-info">
                    Willingness to learn.
                    </p>
                  </li>

                  <li className="services__modal-service">
                    <i className="uil uil-check-circle services__moral-icon"></i>
                    <p className="services__modal-info">
                    Positive attitude.
                    </p>
                  </li>

                  <li className="services__modal-service">
                    <i className="uil uil-check-circle services__moral-icon"></i>
                    <p className="services__modal-info">
                      Team player.
                    </p>
                  </li>

                  <li className="services__modal-service">
                    <i className="uil uil-check-circle services__moral-icon"></i>
                    <p className="services__modal-info">
                      Good communication.
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
